:host {
  height: auto;
}

.form-section {
  margin-top: calc(var(--spacer) * 2.5);
}
